import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgRefresh = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.91 4.065a.74.74 0 11.764 1.267l-1.51.91a6.8 6.8 0 013.397 1.685 7.06 7.06 0 012.282 4.857c.203 3.863-2.699 7.155-6.48 7.354-3.783.198-7.013-2.773-7.215-6.636a.77.77 0 01.72-.817.77.77 0 01.802.737c.157 3.005 2.67 5.315 5.61 5.161 2.942-.154 5.2-2.715 5.042-5.72a5.486 5.486 0 00-1.776-3.777 5.272 5.272 0 00-3.029-1.364l.94 1.852a.74.74 0 01-1.319.67L10.506 7.03a.739.739 0 01-.029-.606.739.739 0 01.346-.499l3.087-1.86z"
      clipRule="evenodd"
    />
  </svg>
));
SvgRefresh.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgRefresh;
